module.exports = __webpack_public_path__ + "static/media/back-btn.45afcf79.svg";